/** Generated by scripts/write-build-info.mjs — do not edit. */
export const BUILD_NO = '261104-9b4d107f-234040';
